import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UIStateService } from '../ui-state.service';

@Component({
  selector: 'mea-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css']
})
export class ActivityComponent implements OnInit, OnDestroy {
  @Input() profession: {name: string, hierarchy: string};

  constructor(private uiState: UIStateService) { }

  ngOnInit() {
    this.uiState.setSubjectList([
      { name: this.profession.name, hierarchy: this.profession.hierarchy },
      { name: '', hierarchy: '' },
      { name: 'בחרו פעילות', hierarchy: '' },
    ]);
    this.uiState.setActivity('_');
  }

  ngOnDestroy() {
    // No subscriptions to clean up
  }

}
